import { createSelector } from 'reselect'

const selectLists = state => state.lists

export const getLists = createSelector(selectLists, lists =>
  Object.values(lists),
)
